<script setup>
import { useDisplay } from "vuetify";
import { INSTRUCTION_TEXTS } from "@/utils/constant";

definePage({
  name: "RanksMobileLoadout",
  path: "/ranks/mobile-loadout",
  meta: {
    layout: "default",
    requiresAuth: true,
    title: "Loadout",
    description: "Review and tweak your battle loadout from the ranks view.",
  },
});

const authStore = useAuthStore();
const router = useRouter();
const { mobile } = useDisplay();
const onboarding = useOnboardingStore();

// Redirect to desktop version on desktop devices
onMounted(() => {
  if (!mobile.value) {
    router.replace("/ranks");
  }

  if (!onboarding.shown.rank) {
    onboarding.showInstruction({
      text: INSTRUCTION_TEXTS.rank,
      onClose: () => onboarding.markShown("rank"),
    });
  }
});
</script>

<template>
  <!-- StarrySky as fixed background -->
  <StarrySky class="" />

  <!-- Main Content -->
  <div class="tw-page-container tw-min-h-screen tw-relative">
    <v-container>
      <div
        class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 xl:tw-grid-cols-[9fr_11fr] tw-gap-4"
      >
        <div class="">
          <my-profile-block />

          <v-divider
            color="#D9D9D9"
            thickness="2"
            length="80%"
            opacity="1"
            class="tw-mx-auto tw-my-4"
          />

          <loadout-block />
        </div>
      </div>
    </v-container>
  </div>
</template>

<style>
/* Mobile specific styles */
.tw-mobile-page-content {
  padding: 16px 0;
}

/* Ensure content is visible above the starfield */
.tw-page-container {
  background-color: transparent;
}
</style>
